import React from 'react';
import { Button } from 'semantic-ui-react';

const GoogleButton = props => (
  <Button
    color="google plus"
    icon="google"
    onClick={props.onSignIn}
    content={props.content || 'Sign in with Google'}
  />
);

export default GoogleButton;



// WEBPACK FOOTER //
// ./src/components/GoogleButton.js